// This expects a dialog target to exist inside element

import { Controller } from "@hotwired/stimulus"
import { fire } from "utils/events";

export default class extends Controller {
  static targets = [
    "dialog"
  ];

  connect() {
    if (!this.hasDialogTarget) {
      console.error('dialog-inline is missing dialog target');
    }
  }

  open(event) {
    event.preventDefault();
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal();
      fire(this.dialogTarget, 'dialog-inline:opened');
    }
  }

  close(event) {
    event.preventDefault();
    if (this.hasDialogTarget) {
      this.dialogTarget.close();
      // fire(this.dialogTarget, 'dialog-inline:closed'); // for if we ever need this
    }
  }
}
